module.exports = __webpack_public_path__ + "static/media/7.af1893a4.jpg";